'use strict';
import angular from 'angular';
import moment from 'moment';

export default class CollecteController {
  /*@ngInject*/
  constructor($stateParams, $location, $rootScope, $http, $state, $scope, $timeout, Borne, toastr) {
    var vm = this;
    vm.loading = true;
    vm.newData = false;
    window.collecte = true;
    vm.clavierCyrilic = false;
    vm.keyboardLayout = "QWE";
    vm.electron = window.electron;
    $scope._ = _;
    $('.modal-backdrop').hide();
    $('#privacyModal').modal('show');
    setTimeout(function() {
      $('.selectpicker').selectpicker('refresh');
    }, 10);

    if(!Borne.Poste) {
      Borne.load($stateParams.borneId).then(function () {
        initPage();
        $scope.$apply();
      })
    } else {
      initPage();
    }
    setInterval(() => {
      console.log(vm.keyboardLayout)

    },2000)

    function initPage() {
      vm.borne = angular.copy(Borne.Poste);
      vm.borne.collecte = {};
      vm.categorie = _.find(Borne.Poste.Categories, ['_id', $stateParams.id]);
      vm.categorie.availableInputs = [];
      _.forEach(vm.categorie.identifiants, function(identifiant){
        _.forEach(Borne.Poste.listeIdentifiants, function(listIdentifiant){
          var id = _.find(Borne.Poste.listeIdentifiants, ['id', identifiant]);
          id.value = "";
          if(identifiant == listIdentifiant.id) vm.categorie.availableInputs.push(id);
        })
      })
      $scope.selectedInput = vm.categorie.availableInputs[0];
      vm.loading = false;
      vm.scanned = Borne.Poste.Session.scanned;
      vm.expired = Borne.Poste.Session.expired;
      if(vm.scanned && Borne.Poste.Session.badge){
        console.log('Badge');
        vm.badge = Borne.Poste.Session.badge;
        vm.borne.collecte = vm.badge.session.collecte;
        _.forEach(vm.borne.collecte, function(identifiant, key){
          var id = _.find(vm.categorie.availableInputs, ['name', key]);
          if(_.find(vm.categorie.availableInputs, ['name', key])) id.value = identifiant;
        })
        if(vm.categorie.impose) {
          vm.borne.Session.collecte.contacts = vm.borne.Session.contacts;
        } else {
          var trueBadge = [];
          _.forEach(vm.badge.session.collecte.contacts, function(contact){
            if(_.find(vm.borne.Session.contacts, ['_id',contact._id])) trueBadge.push(_.find(vm.borne.Session.contacts, ['_id',contact._id]));
          })
          vm.borne.Session.collecte.contacts = trueBadge;
        }
        setTimeout(function() {
          $('.selectpicker').selectpicker('refresh');
        }, 10);
      } else if(vm.scanned){
        console.log('QRCode');
        vm.qrCodeScanned = true;
        _.forEach(Borne.Poste.Session.collecte, function(identifiant, key){
          var id = _.find(vm.categorie.availableInputs, ['name', key]);
          if(_.find(vm.categorie.availableInputs, ['name', key])) id.value = identifiant;
        })
        if(vm.categorie.impose) {
          vm.borne.Session.collecte.contacts = vm.borne.Session.contacts;
        } else {
          var trueBadge = [];
          _.forEach(Borne.Poste.Session.collecte.contacts, function(badge){
            if(_.find(vm.borne.Session.contacts, ['_id',badge._id])) trueBadge.push(_.find(vm.borne.Session.contacts, ['_id',badge._id]));
          })
          vm.borne.Session.collecte.contacts = trueBadge;
        }
      } else {
        console.log('Nothing');
        vm.borne.Session.collecte = {};
        if(vm.categorie.impose) {
          vm.borne.Session.collecte.contacts = vm.borne.Session.contacts;
        } else {
          // vm.borne.Session.collecte.contacts = [vm.borne.Session.contacts[0]];
          setTimeout(function() {
            $('.selectpicker').selectpicker('refresh');
          }, 10);
        }
      }
    }

    vm.next = function() { 
      _.forEach(vm.categorie.availableInputs, function(data){
        Borne.Poste.collecte[data.name] = data.value
      })
      Borne.Poste.Session.collecte = Borne.Poste.collecte
      Borne.Poste.Session.collecte.contacts = vm.borne.Session.collecte.contacts
      window.collecte = false
      if(vm.qrCodeScanned) $location.path('/borne_badge/' + vm.categorie._id + '/' + $stateParams.borneId)
      else $location.path('/borne_formation/' + vm.categorie._id + '/' + $stateParams.borneId)
    }

    vm.printNewBadge = function(){
      $location.path('/borne_badge/' + vm.categorie._id + '/' + $stateParams.borneId)
    }

    vm.changeKeyboard = function(state){
      // vm.clavierCyrilic = state;
      vm.keyboardLayout = state;
    }

    $scope.clavierClick = function ($event) {
      vm.newData = true
      var btn = $($event.target);
      var value = btn.text();
      if ($scope.selectedInput.value == undefined) $scope.selectedInput.value = '';
        if (value == "ESPACE" || value == "SPACE" || value == "Пpoбeл") {
          $scope.selectedInput.value += ' ';
        }
        else if (value == "") {
          if ($scope.selectedInput.value.length > 0)
            $scope.selectedInput.value = $scope.selectedInput.value.substr(0, $scope.selectedInput.value.length - 1);
        }
        else {
          $scope.selectedInput.value += value;
        }
    }

    $scope.$watch('vm.borne.Session.collecte.contacts', function (nv) {
      vm.borne.Session.collecte.contacts = nv
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    })

    $scope.selectInput = function ($event, input) {
      var btn = $($event.target);
      $("input").removeClass("focus");
      btn.addClass('focus')
      $scope.selectedInput = input;

      if($(btn).attr('id') == 'nom' || $(btn).attr('id') == 'prenom' || $(btn).attr('id') == 'ville') {
        $scope.clavierNumeric = false
      } else {
        $scope.clavierNumeric = true;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./client/app/borne/collecte/collecte.controller.js